// extracted by mini-css-extract-plugin
export default {"gameOver":"GameOver_gameOver__gCv3G","scoreBoard":"GameOver_scoreBoard__hif2G","timeTaken":"GameOver_timeTaken__krUDC","buttonWrapper":"GameOver_buttonWrapper__LY5vO"};